//frontend/src/components/common/PasswordInput.js
import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Check, X, Info } from 'lucide-react';

const PasswordInput = ({ 
    name, 
    placeholder, 
    value, 
    onChange, 
    showValidation = false,
    showExamples = false 
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [localShow, setLocalShow] = useState(false);

    // قوانین اعتبارسنجی
    const validationRules = [
        { rule: value.length >= 8, message: "حداقل ۸ کاراکتر" },
        { rule: /[A-Z]/.test(value), message: "حداقل یک حرف بزرگ انگلیسی" },
        { rule: /[a-z]/.test(value), message: "حداقل یک حرف کوچک انگلیسی" },
        { rule: /[0-9]/.test(value), message: "حداقل یک عدد" },
        { rule: /[!@#$%^&*(),.?":{}|<>]/.test(value), message: "کاراکتر ویژه (!@#$)" }
    ];

    const isPasswordValid = validationRules.every(rule => rule.rule);
    const passedRulesCount = validationRules.filter(rule => rule.rule).length;

    return (
        <div className="relative mb-4 w-full" dir="ltr">
            <div className="relative flex items-center">
                {/* آیکون قفل سمت راست (RTL View) */}
                <div className="absolute right-3 text-gray-400 z-10">
                    <Lock size={18} />
                </div>

                <input
                    type={localShow ? "text" : "password"}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    placeholder={placeholder}
                    required
                    className={`
                        w-full py-3 pr-10 pl-10 rounded-lg border bg-white text-gray-900 
                        focus:ring-2 focus:ring-purple-600 focus:border-transparent 
                        outline-none transition-all duration-200 placeholder-gray-400 text-left
                        ${showValidation && value.length > 0 ? (isPasswordValid ? 'border-green-400' : 'border-red-400') : 'border-gray-300'}
                    `}
                />
                
                {/* دکمه چشم سمت چپ */}
                <button
                    type="button"
                    onClick={() => setLocalShow(!localShow)}
                    className="absolute left-3 flex items-center justify-center text-gray-400 hover:text-purple-600 cursor-pointer z-20 p-1"
                    tabIndex="-1"
                >
                    {localShow ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
            </div>

            {/* بخش نمونه‌ها و قوانین (فقط در صورت نیاز نمایش داده می‌شود) */}
            {showValidation && value.length > 0 && (
                <div className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded-lg shadow-sm" dir="rtl">
                    <div className="space-y-1">
                        {validationRules.map((rule, i) => (
                            <div key={i} className="flex items-center gap-2 text-xs">
                                {rule.rule ? <Check size={14} className="text-green-600" /> : <X size={14} className="text-red-500" />}
                                <span className={rule.rule ? 'text-green-700' : 'text-red-600'}>{rule.message}</span>
                            </div>
                        ))}
                    </div>
                    {/* نوار قدرت پسورد */}
                    <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5">
                        <div 
                            className={`h-1.5 rounded-full transition-all duration-500 ${passedRulesCount < 3 ? 'bg-red-500' : passedRulesCount < 5 ? 'bg-yellow-500' : 'bg-green-500'}`}
                            style={{ width: `${(passedRulesCount / 5) * 100}%` }}
                        ></div>
                    </div>
                </div>
            )}

            <style>{`
                input[name="${name}"]::placeholder { text-align: right; direction: rtl; }
            `}</style>
        </div>
    );
};

export default PasswordInput;